import { giftCodeExperienceURL } from 'endpoints';
import createStyles from '../utils/create-styles';
import fetch from '../utils/fetch';


/*******************************************************************************
 * Initial state
 */
const initialState = {
	id: null,
	name: '',
	primaryColor: '',
	primaryLogo: '',
	contactEmailAddress: '',
	countryList: [],
	companyLoading: false,
	defaultLocaleCode: ''
};

/*******************************************************************************
 * Non-async action types
 */
export const SET_COMPANY       = 'SET_COMPANY';
export const COMPANY_LOADING   = 'COMPANY_LOADING';

/*******************************************************************************
 * Reducer
 */
export default function appReducer( state = initialState, action ) {
	switch ( action.type ) {
		case SET_COMPANY: {
			return {
				...state,
				...action.company
			};
		}
		case COMPANY_LOADING: {
			return {
				...state,
				companyLoading: action.flag
			};
		}
		default:
			return state;
	}
}

/*******************************************************************************
 * Action creators
 */
export function getCompany( ) {
    return ( dispatch ) => {
        dispatch( companyLoading( true ) );
        return fetch( `${ giftCodeExperienceURL }/company`, {
            method: 'GET',
            headers: { 'content-type': 'application/json' }
        } )
        .then( ( res ) => {
            if ( res.ok ) {
                return res.json().then( ( data ) => {
                    dispatch( setCompany( data ) );
                    dispatch( companyLoading( false ) );
                } );
            } else {
                return res.json().then( ( data ) => {
                    dispatch( companyLoading( false ) );
                    throw new Error( data );
                } );
            }
        } )
        .catch ( ( err ) => {
            dispatch( companyLoading( false ) );
            throw new Error( err );
        } );
    };
}

export function setCompany( company ) {
	//Create CSS Style Sheet in the DOM
	createStyles( company );

	return {
		type: SET_COMPANY,
		company
	};
}

export function companyLoading( flag ) {
	return {
		type: COMPANY_LOADING,
		flag
	};
}
